<!-- setting.component.html -->
<div class="max-w-screen-xl p-6 mx-auto space-y-6">

  <!-- En-tête de la page -->
  <!-- <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">⚙️ Paramètres</h1>
      <p class="mt-1 text-sm text-gray-500">Gérez votre profil et suivez l'état de votre licence</p>
    </div>
     <div class="px-4 py-2 bg-blue-100 rounded-lg">
      <span class="text-sm font-medium text-blue-800">
        {{ isSuperAdmin ? '👑 Super Administrateur' : '👤 Utilisateur' }}
      </span>
    </div>
  </div> -->



  <!-- Message si aucune licence -->
  <div *ngIf="(userLicence$ | async) === null && !isSuperAdmin"
    class="overflow-hidden bg-white border border-gray-100 shadow-md rounded-xl">
    <div class="px-6 py-4 bg-gradient-to-r from-yellow-500 to-orange-500">
      <h2 class="text-lg font-semibold text-white">⚠️ Licence manquante</h2>
    </div>
    <div class="p-8 text-center">
      <svg class="w-20 h-20 mx-auto text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
        </path>
      </svg>
      <h3 class="mt-4 text-lg font-medium text-gray-800">Aucune licence trouvée</h3>
      <p class="mt-2 text-sm text-gray-600">
        Vous n'avez pas encore de licence active. Veuillez contacter l'administrateur.
      </p>
      <button *ngIf="!isSuperAdmin" (click)="requestLicence()"
        class="px-4 py-2 mt-4 text-sm font-medium text-white transition-colors bg-yellow-500 rounded-lg hover:bg-yellow-600">
        📝 Demander une licence
      </button>
    </div>
  </div>


</div>


<!-- setting.component.html -->
<div class="max-w-screen-xl p-6 mx-auto">

  <!-- En-tête avec effet glassmorphism -->
  <div class="relative mb-8 overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900">
    <div class="absolute inset-0 6 opacity-10"></div>
    <div class="relative px-8 py-8">
      <div class="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 class="text-3xl font-bold tracking-tight text-white">Licence & Informations</h1>
          <p class="mt-1 text-gray-300">Suivez l'état de votre licence et accédez aux ressources utiles</p>
        </div>
        <div class="flex items-center space-x-3">
          <div class="px-4 py-2 border bg-white/10 backdrop-blur-sm rounded-xl border-white/20">
            <span class="text-sm font-medium text-white">
              {{ isSuperAdmin ? '👑 Super Administrateur' : '📋 Utilisateur' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grille principale -->
  <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">

    <!-- Colonne principale - Licence (2/3 de largeur) -->
    <div class="lg:col-span-2">

      <!-- Section Licence avec affichage dynamique -->
      <div *ngIf="userLicence$ | async as licence"
        class="overflow-hidden transition-shadow duration-300 bg-white border border-gray-100 shadow-sm rounded-2xl hover:shadow-md">

        <!-- En-tête avec statut -->
        <div class="px-6 py-5 border-b border-gray-100">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex items-center space-x-3">
              <div class="w-1 h-8 rounded-full bg-gradient-to-b from-purple-500 to-pink-500"></div>
              <div>
                <h2 class="text-xl font-semibold text-gray-800">Ma licence</h2>
                <p class="text-xs text-gray-500 mt-0.5">Détails et validité</p>
              </div>
            </div>
            <div class="flex items-center space-x-2">
              <div class="w-2 h-2 rounded-full animate-pulse"
                [ngClass]="licence.status === 'ACTIF' ? 'bg-green-500' : 'bg-red-500'"></div>
              <span [class]="'text-xs font-medium px-3 py-1.5 rounded-full ' + getStatusClass(licence.status)">
                <span class="mr-1">{{ getStatusIcon(licence.status) }}</span>
                {{ getStatusText(licence.status) }}
              </span>
            </div>
          </div>
        </div>

        <div class="p-6">
          <!-- Métriques clés -->
          <div class="grid grid-cols-2 gap-5 mb-8 sm:grid-cols-4">
            <div class="p-3 text-center bg-gray-50 rounded-xl">
              <div class="mb-1 text-xs tracking-wider text-gray-500 uppercase">N° Licence</div>
              <div class="font-mono text-lg font-bold text-gray-800">{{ licence.numerolicence || '---' }}
              </div>
            </div>
            <div class="p-3 text-center bg-gray-50 rounded-xl">
              <div class="mb-1 text-xs tracking-wider text-gray-500 uppercase">Type</div>
              <div class="text-lg font-bold" [ngClass]="licence.isPro ? 'text-purple-600' : 'text-green-600'">
                {{ licence.isPro ? '💎 PROFESSIONNELLE' : '🎁 GRATUITE' }}
              </div>
            </div>
            <div class="p-3 text-center bg-gray-50 rounded-xl">
              <div class="mb-1 text-xs tracking-wider text-gray-500 uppercase">Pays</div>
              <div class="text-lg font-bold text-gray-800">{{ licence.pays || '---' }}</div>
            </div>
            <div class="p-3 text-center bg-gray-50 rounded-xl">
              <div class="mb-1 text-xs tracking-wider text-gray-500 uppercase">Jours de grâce</div>
              <div class="text-lg font-bold text-gray-800">{{ licence.graceDays || 0 }}</div>
            </div>
          </div>

          <!-- Période de validité -->
          <div class="pt-4 mt-2 border-t border-gray-100">
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center space-x-2">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                <span class="text-sm font-medium text-gray-700">Période de validité</span>
              </div>
              <span class="text-sm font-semibold" [ngClass]="daysRemaining >= 0 ? 'text-green-600' : 'text-red-600'">
                {{ daysRemaining >= 0 ? daysRemaining + ' jours restants' : 'Expirée depuis ' + Math.abs(daysRemaining)
                + ' jours' }}
              </span>
            </div>

            <!-- Barre de progression -->
            <div class="relative h-2 overflow-hidden bg-gray-100 rounded-full">
              <div
                class="absolute h-full transition-all duration-500 rounded-full bg-gradient-to-r from-green-500 to-blue-500"
                [style.width]="progressPercentage + '%'"></div>
            </div>

            <div class="flex justify-between mt-3 text-xs text-gray-500">
              <div class="flex items-center space-x-1">
                <span>📅</span>
                <span>{{ formatDate(licence.dateCreation || licence.createdAt) }}</span>
              </div>
              <div class="flex items-center space-x-1">
                <span>⚠️</span>
                <span>{{ formatDate(licence.dateExpiration) }}</span>
              </div>
            </div>

            <!-- Message jours de grâce -->
            <div *ngIf="daysRemaining < 0 && graceDaysRemaining > 0"
              class="p-4 mt-5 border border-orange-200 bg-orange-50 rounded-xl">
              <div class="flex items-center space-x-3">
                <div class="flex items-center justify-center w-8 h-8 bg-orange-100 rounded-full">
                  <svg class="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-medium text-orange-800">Période de grâce active</p>
                  <p class="text-xs text-orange-600">{{ graceDaysRemaining }} jours restants avant désactivation
                    définitive</p>
                </div>
              </div>
            </div>

            <!-- Message licence expirée sans grâce -->
            <div *ngIf="daysRemaining < 0 && graceDaysRemaining <= 0 && licence.status === 'EXPIRE'"
              class="p-4 mt-5 border border-red-200 bg-red-50 rounded-xl">
              <div class="flex items-center space-x-3">
                <div class="flex items-center justify-center w-8 h-8 bg-red-100 rounded-full">
                  <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636">
                    </path>
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-medium text-red-800">Licence expirée</p>
                  <p class="text-xs text-red-600">Veuillez contacter l'administrateur pour renouveler votre licence</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Message si aucune licence -->
      <div *ngIf="(userLicence$ | async) === null && !isSuperAdmin"
        class="overflow-hidden bg-white border border-gray-100 shadow-sm rounded-2xl">
        <div class="px-6 py-12 text-center">
          <div
            class="flex items-center justify-center w-20 h-20 mx-auto mb-5 shadow-lg bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
              </path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-gray-800">Aucune licence trouvée</h3>
          <p class="max-w-sm mx-auto mt-2 text-sm text-gray-500">
            Vous n'avez pas encore de licence active. Veuillez contacter l'administrateur pour obtenir une licence.
          </p>
          <button (click)="requestLicence()"
            class="mt-6 px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            📝 Contacter l'administrateur
          </button>
        </div>
      </div>

      <!-- Message super admin -->
      <div *ngIf="isSuperAdmin" class="overflow-hidden bg-white border border-gray-100 shadow-sm rounded-2xl">
        <div class="px-6 py-12 text-center">
          <div
            class="flex items-center justify-center w-20 h-20 mx-auto mb-5 shadow-lg bg-gradient-to-br from-blue-500 to-indigo-500 rounded-2xl">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
              </path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-gray-800">Mode Administrateur</h3>
          <p class="max-w-sm mx-auto mt-2 text-sm text-gray-500">
            Vous êtes connecté en tant que Super Administrateur. Vous avez un accès complet à l'application.
          </p>
          <button routerLink="/manage-licence"
            class="mt-6 px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-indigo-500 rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            ⚙️ Gérer les licences
          </button>
        </div>
      </div>
    </div>

    <!-- Colonne de droite - Informations utiles (1/3 de largeur) -->
    <div class="space-y-6">

      <!-- Carte Support technique -->
      <div
        class="overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-sm rounded-2xl hover:shadow-md">
        <div class="px-5 py-4 bg-gradient-to-r from-blue-50 to-indigo-50">
          <div class="flex items-center space-x-2">
            <div class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-xl">
              <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M18.364 5.636L16.95 7.05M21 12h-3M4 12H1m7.05-4.95L6.636 5.636M12 3v3m0 16v-3m4.95-4.95l1.414 1.414M5.636 18.364l1.414-1.414">
                </path>
              </svg>
            </div>
            <h3 class="font-semibold text-gray-800">Support technique</h3>
          </div>
        </div>
        <div class="p-5 space-y-4">
          <div class="flex items-center justify-between pb-2 border-b border-gray-100">
            <span class="text-sm text-gray-500">📧 Email</span>
            <a href="mailto:support@certiport.com"
              class="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700">support@certiport.com</a>
          </div>
          <div class="flex items-center justify-between pb-2 border-b border-gray-100">
            <span class="text-sm text-gray-500">📞 Téléphone</span>
            <span class="text-sm font-medium text-gray-800">+228 70 00 00 00</span>
          </div>
          <div class="flex items-center justify-between">
            <span class="text-sm text-gray-500">💬 WhatsApp</span>
            <span class="text-sm font-medium text-gray-800">+228 90 00 00 00</span>
          </div>
        </div>
      </div>

      <!-- Carte Procédures portuaires -->
      <div
        class="overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-sm rounded-2xl hover:shadow-md">
        <div class="px-5 py-4 bg-gradient-to-r from-green-50 to-emerald-50">
          <div class="flex items-center space-x-2">
            <div class="flex items-center justify-center w-8 h-8 bg-green-100 rounded-xl">
              <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
                </path>
              </svg>
            </div>
            <h3 class="font-semibold text-gray-800">Procédures portuaires</h3>
          </div>
        </div>
        <div class="p-5">
          <ul class="space-y-3">
            <li class="flex items-start p-2 space-x-3 transition-colors rounded-lg cursor-pointer hover:bg-gray-50">
              <span class="text-sm text-green-500">✓</span>
              <span class="text-sm text-gray-600">Guide d'inspection des véhicules</span>
            </li>
            <li class="flex items-start p-2 space-x-3 transition-colors rounded-lg cursor-pointer hover:bg-gray-50">
              <span class="text-sm text-green-500">✓</span>
              <span class="text-sm text-gray-600">Manuel de conformité portuaire</span>
            </li>
            <li class="flex items-start p-2 space-x-3 transition-colors rounded-lg cursor-pointer hover:bg-gray-50">
              <span class="text-sm text-green-500">✓</span>
              <span class="text-sm text-gray-600">Procédure de délivrance des badges</span>
            </li>
            <li class="flex items-start p-2 space-x-3 transition-colors rounded-lg cursor-pointer hover:bg-gray-50">
              <span class="text-sm text-green-500">✓</span>
              <span class="text-sm text-gray-600">Règlementation douanière</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Carte Horaires -->
      <div
        class="overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-sm rounded-2xl hover:shadow-md">
        <div class="px-5 py-4 bg-gradient-to-r from-purple-50 to-pink-50">
          <div class="flex items-center space-x-2">
            <div class="flex items-center justify-center w-8 h-8 bg-purple-100 rounded-xl">
              <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 class="font-semibold text-gray-800">Horaires d'ouverture</h3>
          </div>
        </div>
        <div class="p-5 space-y-3">
          <div class="flex items-center justify-between p-2 transition-colors rounded-lg hover:bg-gray-50">
            <span class="text-sm text-gray-600">Lundi - Vendredi</span>
            <span class="text-sm font-semibold text-gray-800">08:00 - 18:00</span>
          </div>
          <div class="flex items-center justify-between p-2 transition-colors rounded-lg hover:bg-gray-50">
            <span class="text-sm text-gray-600">Samedi</span>
            <span class="text-sm font-semibold text-gray-800">08:00 - 12:00</span>
          </div>
          <div class="flex items-center justify-between p-2 rounded-lg bg-gray-50">
            <span class="text-sm text-gray-500">Dimanche & Jours fériés</span>
            <span class="text-sm font-medium text-gray-500">Fermé</span>
          </div>
        </div>
      </div>

      <!-- Carte Liens rapides -->
      <div class="overflow-hidden bg-white border border-gray-100 shadow-sm rounded-2xl">
        <div class="px-5 py-4 bg-gradient-to-r from-gray-50 to-gray-100">
          <div class="flex items-center space-x-2">
            <div class="flex items-center justify-center w-8 h-8 bg-gray-200 rounded-xl">
              <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.102m3.172-3.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.102">
                </path>
              </svg>
            </div>
            <h3 class="font-semibold text-gray-800">Liens rapides</h3>
          </div>
        </div>
        <div class="p-5 space-y-2">
          <a routerLink="/aide"
            class="flex items-center justify-between p-2 transition-colors rounded-lg hover:bg-blue-50 group">
            <span class="text-sm text-gray-600 group-hover:text-blue-600">📖 Centre d'aide</span>
            <svg class="w-4 h-4 text-gray-400 group-hover:text-blue-600" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </a>
          <a routerLink="/profil"
            class="flex items-center justify-between p-2 transition-colors rounded-lg hover:bg-blue-50 group">
            <span class="text-sm text-gray-600 group-hover:text-blue-600">👤 Mon profil</span>
            <svg class="w-4 h-4 text-gray-400 group-hover:text-blue-600" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>

      <!-- Version -->
      <div class="py-4 text-center">
        <p class="text-xs text-gray-400">Version 2.0.0</p>
        <p class="mt-1 text-xs text-gray-400">© 2024 CERTIPORT</p>
      </div>
    </div>
  </div>
</div>
